import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShareFeedbackProps } from "../../../src/type";
import { post } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const shareFeedback = createAsyncThunk(
  "shareFeedback/sendFeedback",
  async (requestData: ShareFeedbackProps, storeActions) => {
    const url = `api/v1/user/feedbacks`;
    const response: any = await post(url, requestData, storeActions);

    if (response.status === HttpStatus.CREATED) {
      return {
        status: HttpStatus.CREATED,
      };
    }
    return {
      status: response.status,
    };
  }
);

const shareFeedbackSlice = createSlice({
  name: "shareFeedback",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    unsavedChanges: false as  boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
    },
    setUnsavedChanges: (state, action) => {
      state.unsavedChanges = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      shareFeedback.fulfilled,
      (state, { payload }: PayloadAction<{ status: number }>) => {
        state.status = payload.status;
        state.loading = false;
      }
    );
    builder.addCase(shareFeedback.pending, (state) => {
      state.loading = true;
      state.status = null;
    });
    builder.addCase(shareFeedback.rejected, (state) => {
      state.status = 503;
      state.loading = false;
    });
  },
});

export const { clearData, setUnsavedChanges } = shareFeedbackSlice.actions;

export default shareFeedbackSlice;
